/* =====================================================================
 * DMEmojiPicker — DM용 이모지 피커 래퍼
 *
 * 공통 EmojiPicker를 DM 인터페이스에 맞게 래핑합니다.
 * 기존 DMEmojiPickerProps 인터페이스를 유지하여 하위 호환성을 보장합니다.
 * ===================================================================== */

import React from 'react';
import { EmojiPicker } from '@auw/workspace-ui';

interface DMEmojiPickerProps {
  onSelect: (emoji: string) => void;
  onClose: () => void;
  anchorRect?: DOMRect | null;
  isUser?: boolean;
}

const DMEmojiPicker: React.FC<DMEmojiPickerProps> = ({
  onSelect,
  onClose,
  anchorRect,
  isUser = false,
}) => (
  <EmojiPicker
    onSelect={onSelect}
    onClose={onClose}
    anchorRect={anchorRect}
    alignRight={isUser}
  />
);

export default DMEmojiPicker;
